import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { T } from '../../i18n/index.js'

export const AnalyticsSectionTitle = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-row items-center">
      <h3 className="text-heading-sm font-medium text-content-on-background">
        {title}
      </h3>
      <Tooltip key="analytics-tz-notice-tooltip">
        <Tooltip.Trigger className="ms-2 mt-1">
          <SvgIcon className="w-5 h-5" name="info" />
        </Tooltip.Trigger>
        <Tooltip.Panel>
          <T
            id="Analytics.SectionTitle.TimezoneNotice"
            defaultMessage="All metrics are calculated and displayed based on Coordinated Universal Time (UTC)."
          />
        </Tooltip.Panel>
      </Tooltip>
    </div>
  )
}
